import React from 'react';

import Logo from 'components/shared/Icon/icons/Logo';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import styles from './index.module.css';
import Links from './Links';

function Navigation() {
  const { isTabletOrMobile } = useMediaBreakpoints();

  if (isTabletOrMobile) return null;

  return (
    <div className={styles.block} data-e2e-widget-type="navigationWidget">
      <div className={styles.logo} data-e2e-element-id="safariLogo">
        <Logo width="9.8rem" height="3rem" />
      </div>

      <Links />
    </div>
  );
}

export default Navigation;
